import bootbox from 'bootbox';
import 'parsleyjs';

$(document).ready(function() {
  const hostname = window.location.hostname;
  const apiHost = (hostname === 'epact.energy.gov') ? 'developer.nlr.gov' : 'devstage.nlr.gov';

  // URL param type mapping
  const typeMap = {
    'schedule_call': 'Schedule a call with the team',
    'reporting_help': 'Reporting help',
    'alternative_compliance': 'Alternative Compliance',
    'credits': 'Credits',
    'account_fleet': 'Account or fleet management',
    'general_compliance': 'General compliance or regulatory questions',
    'other': 'Other'
  };

  // Pre-select inquiry type from URL param and scroll to form
  const urlParams = new URLSearchParams(window.location.search);
  const typeParam = urlParams.get('type');
  if (typeParam && typeMap[typeParam]) {
    $('#contact_inquiry_type').val(typeMap[typeParam]);
    const formAnchor = document.getElementById('contact-form');
    if (formAnchor) {
      formAnchor.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // Update hidden fleet ID when fleet dropdown changes
  $('#contact_fleet').on('change', function() {
    var selected = $(this).find(':selected');
    var fleetId = selected.data('fleet-id') || '';
    $('#contact_fleet_id').val(fleetId);
  });

  // Form validation and submission
  var form = $("#epact_contact_form");
  form.parsley();
  form.submit(function(event) {
    var submit = $(this).find('button');
    submit.button('loading');

    event.preventDefault();

    // Build the subject with inquiry type prefix
    var inquiryType = $('#contact_inquiry_type').val();
    var userSubject = $('#contact_subject').val();
    var fullSubject = '[' + inquiryType + '] ' + userSubject;

    // Build the message with fleet info prefix
    var fleetName = $('#contact_fleet').val();
    var fleetId = $('#contact_fleet_id').val();
    var userMessage = $('#contact_message').val();
    var fullMessage = userMessage;

    if (fleetName) {
      var fleetPrefix = 'Fleet: ' + fleetName;
      if (fleetId) {
        fleetPrefix += ' (ID: ' + fleetId + ')';
      }
      fullMessage = fleetPrefix + '\n\n' + userMessage;
    }

    // Build form data manually to use transformed values
    var data = {
      'contact[name]': $('#contact_name').val(),
      'contact[email]': $('#contact_email').val(),
      'contact[subject]': fullSubject,
      'contact[message]': fullMessage,
      'contact[project]': $('#contact_project').val()
    };

    $.ajax({
      url: 'https://' + apiHost + '/api/contactor/v1.json?api_key=Tjs6gE5M1cPVD4LUR3oSsEVgOZCtAlXZLVDtgNI8',
      type: 'POST',
      data: data,
      dataType: 'json',
    }).done(function(response) {
      bootbox.alert('Thanks for sending your message. We\'ll be in touch.', function() {
        form.trigger('reset');
      });
    }).fail(function(xhr, message, error) {
      if(typeof(Rollbar) != 'undefined') {
        Rollbar.error('Unexpected contact sending failure', { error: error, message: message, response: xhr.responseText });
      }

      bootbox.alert('Sending your message unexpectedly failed.<br>Please try again.');
    }).always(function() {
      submit.button('reset');
    });
  });
});
